import React from "react";
import { Modal, Form, Button, Badge, InputGroup } from "react-bootstrap";
import ProSourceForm from "../../../components/ProSourceForm";
import { get } from "lodash";
import { tryParse } from "../../../helpers";

const CELEBRATION_OPTIONS = [
  "Birthday",
  "Anniversary",
  "Graduation",
  "Engagement",
  "Reunion",
  "Promotion",
  "Baby Shower",
  "Bridal Shower",
  "Wedding",
];

const purpleColor = "#8950fc";

const basePillStyle = {
  margin: "0.25rem",
  padding: "0.5rem 0.75rem",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "500",
  transition: "all 0.2s ease",
  border: "none",
  borderRadius: "50rem",
};

const experiencePillStyle = {
  ...basePillStyle,
  backgroundColor: "#f0f0f0",
  color: "#555",
};

const activeExperiencePillStyle = {
  ...basePillStyle,
  backgroundColor: purpleColor,
  color: "#ffffff",
};

export default class EditCelebrationModal extends ProSourceForm {
  constructor(props) {
    super(props);
    const { reservation } = props;
    const notes = tryParse(reservation.notes) || {};

    this.state = {
      values: {
        celebration: get(notes, "celebration", []),
        otherCelebrationNote: "",
      },
      errors: {},
      touched: {},
      isSubmitting: false,
    };
  }

  handleSelectItem = (itemName) => {
    const { values } = this.state;
    const currentItems = [...values.celebration];
    const existingItemIndex = currentItems.findIndex(
      (item) => item.label.toLowerCase() === itemName.toLowerCase(),
    );

    let newItems;
    if (existingItemIndex > -1) {
      newItems = currentItems.filter(
        (item) => item.label.toLowerCase() !== itemName.toLowerCase(),
      );
    } else {
      newItems = [...currentItems, { label: itemName, count: 1 }];
    }

    this.handleOnChange({ target: { name: "celebration", value: newItems } });
  };

  handleAddCustomItem = () => {
    const { values } = this.state;
    const itemName = values.otherCelebrationNote.trim();
    if (!itemName) return;

    const itemExists = values.celebration.some(
      (item) => item.label.toLowerCase() === itemName.toLowerCase(),
    );

    if (itemExists) {
      this.handleOnChange({
        target: { name: "otherCelebrationNote", value: "" },
      });
      return;
    }

    const newItems = [...values.celebration, { label: itemName, count: 1 }];
    this.handleOnChange({ target: { name: "celebration", value: newItems } });
    this.handleOnChange({
      target: { name: "otherCelebrationNote", value: "" },
    });
  };

  onSubmit = (values, setSubmitting) => {
    this.props.onSubmit(values, setSubmitting);
  };

  render() {
    const { show, onHide } = this.props;
    const { values, isSubmitting } = this.state;
    const inputActions = {
      onChange: this.handleOnChange,
      onBlur: this.handleOnBlur,
    };

    return (
      <Modal show={show} onHide={onHide} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit Celebrations</Modal.Title>
        </Modal.Header>
        <Form onSubmit={this.handleOnSubmit}>
          <Modal.Body>
            <Form.Group
              className="mb-3 p-3 border rounded"
              style={{ backgroundColor: "#f8f9fa" }}
            >
              <Form.Label>Celebration</Form.Label>
              <div>
                {CELEBRATION_OPTIONS.map((option) => (
                  <Badge
                    key={option}
                    pill
                    style={
                      values.celebration.some((item) => item.label === option)
                        ? activeExperiencePillStyle
                        : experiencePillStyle
                    }
                    onClick={() => this.handleSelectItem(option)}
                  >
                    {option}
                  </Badge>
                ))}
              </div>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label htmlFor="otherCelebrationNoteInput">
                Other Occasion
              </Form.Label>
              <InputGroup>
                <Form.Control
                  id="otherCelebrationNoteInput"
                  name="otherCelebrationNote"
                  value={values.otherCelebrationNote}
                  style={{ backgroundColor: "#f8f9fa" }}
                  placeholder="e.g., Family Reunion"
                  onChange={inputActions.onChange}
                  onBlur={inputActions.onBlur}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.handleAddCustomItem();
                    }
                  }}
                />
                <Button
                  variant="outline-secondary"
                  onClick={this.handleAddCustomItem}
                >
                  Add
                </Button>
              </InputGroup>
            </Form.Group>

            {values.celebration.length > 0 && (
              <div
                className="mb-3 p-3 border rounded"
                style={{ backgroundColor: "#ffffff" }}
              >
                {values.celebration.map((item, index) => (
                  <div
                    key={item.label}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "0.5rem 0",
                      borderBottom:
                        index === values.celebration.length - 1
                          ? "none"
                          : "1px solid #eee",
                    }}
                  >
                    <span style={{ fontWeight: "500" }}>{item.label}</span>
                    <Button
                      variant="light"
                      size="sm"
                      style={{
                        padding: "0.25rem 0.6rem",
                        margin: "0 0.25rem",
                        lineHeight: 1,
                      }}
                      onClick={() => this.handleSelectItem(item.label)}
                    >
                      &times;
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={onHide} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              type="submit"
              style={{ backgroundColor: purpleColor, borderColor: purpleColor }}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save Changes"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}
